import React from 'react';
import { Link } from 'react-router-dom';

function MenuButton({ toggleSidebar }) {
    return (
        <button
            id="menu-btn"
            aria-label="Menu"
            className="mobile__active menu-btn with-after2" onClick={toggleSidebar}
        >
            <span>☰</span>
        </button>

    );
}

export default MenuButton;
